import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardActionArea from '@mui/material/CardActionArea';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
// Iconos apropiados para eventos
import CelebrationIcon from '@mui/icons-material/Celebration';
import FavoriteIcon from '@mui/icons-material/Favorite';
import CakeIcon from '@mui/icons-material/Cake';
import UpcomingIcon from '@mui/icons-material/Upcoming';
import EventIcon from '@mui/icons-material/Event';
import PendingActionsIcon from '@mui/icons-material/PendingActions';
import '../../Styles/Menu/Events.css';

const Events = () => {
  const navigate = useNavigate();

  const cardStyle = {
    maxWidth: 275,
    height: 180,
    boxShadow: '0 4px 12px rgba(75, 0, 130, 0.15)',
    borderRadius: '12px',
    transition: 'all 0.3s ease',
    '&:hover': {
      transform: 'translateY(-4px)',
      boxShadow: '0 8px 24px rgba(75, 0, 130, 0.25)',
    }
  };

  const iconStyle = {
    fontSize: 40,
    color: '#4b0082',
    opacity: 0.8
  };

  const eventsMenuOptions = [
    {
      title: 'Reservar Quinceaños',
      description: 'Agendar una nueva reservación para un evento de quince años.',
      path: `/events/reservation-form-xv`,
      icon: <CelebrationIcon sx={iconStyle} />
    },
    {
      title: 'Reservar Bodas',
      description: 'Agendar una nueva reservación para un evento de bodas.',
      path: `/events/reservation-form-boda`,
      icon: <FavoriteIcon sx={iconStyle} />
    },
    {
      title: 'Reservar cumpleaños',
      description: 'Agendar una nueva reservación para un evento de cumpleaños.',
      path: `/events/reservation-form-birthday`,
      icon: <CakeIcon sx={iconStyle} />
    },
    {
      title: 'Visualizar próximas reservaciones',
      description: 'Lista detallada de las reservaciones próximas.',
      path: `/events/closest-events-list`,
      icon: <UpcomingIcon sx={iconStyle} />
    },
    {
      title: 'Visualizar reservaciones',
      description: 'Lista detallada de todas las reservaciones.',
      path: `/events/events-list`,
      icon: <EventIcon sx={iconStyle} />
    },
    {
      title: 'Confirmar Selección de fotos',
      description: 'Confirma la selección de fotos del evento.',
      path: `/events/pending-confirmation`,
      icon: <PendingActionsIcon sx={iconStyle} />
    },
  ];

  const handleNavigate = (path) => {
    setTimeout(() => {
      navigate(path)
    }, 100)
  }

  return (
    <div className='pointofsale-main-container'>
      <div className='pointofsale-container'>
        {eventsMenuOptions.length > 0 && eventsMenuOptions.map((option, index) => (
          <div className='cashflow-opt-container grid-obj' key={index}>
            <Card sx={cardStyle}>
              <CardActionArea sx={{ height: 180 }} onClick={() => handleNavigate(option.path)}>
                <CardContent sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  height: 150,
                  justifyContent: 'space-between',
                  padding: '20px'
                }}>
                  <div className='content-container'>
                    <Typography sx={{
                      color: '#4b0082',
                      fontWeight: 'bold',
                      marginBottom: '8px'
                    }} gutterBottom variant="h5" component="div">
                      {option.title}
                    </Typography>
                    <Typography variant="body2" sx={{
                      color: 'text.secondary',
                      lineHeight: 1.4,
                      textAlign: 'justify'
                    }}>
                      {option.description}
                    </Typography>
                  </div>
                  <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                    {option.icon}
                  </Box>
                </CardContent>
              </CardActionArea>
            </Card>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Events;